import * as PropTypes from 'prop-types';
import { EmptyCell } from 'components/Kizen/Table';
import { getColumnNumeric } from 'components/Fields/InlineTableFieldInput';
import { SortableHeadCell } from './SortableHeadCell';
import { getFieldsDescription } from 'components/Fields/FieldInput/helpers';

export const CustomFieldHeadCell = ({
  field = null,
  column = null,
  ...others
}) => {
  if (!field) {
    return <EmptyCell {...others} />;
  }
  const { withNameDescription } = getFieldsDescription({
    ...field,
    displayName: column?.label || field?.displayName,
  });
  return (
    <SortableHeadCell
      by={field.name}
      numeric={getColumnNumeric(field)}
      column={column}
      {...others}
      description={withNameDescription}
    />
  );
};

CustomFieldHeadCell.propTypes = {
  field: PropTypes.shape({
    id: PropTypes.string.isRequired,
    fieldType: PropTypes.string.isRequired,
  }),
  column: PropTypes.shape({ id: PropTypes.string.isRequired }),
};
